import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-concrete-900">
      {/* Back Button Header */}
      <div className="fixed top-0 left-0 right-0 bg-white border-b border-concrete-200 z-50">
        <div className="container mx-auto px-3 md:px-4 py-3 md:py-4">
          <Link to="/">
            <Button variant="ghost" className="gap-2 text-black hover:bg-concrete-100 text-sm md:text-base px-2 md:px-4">
              <ArrowLeft size={18} className="md:w-5 md:h-5" /> <span className="hidden sm:inline">Zurück zur Website</span><span className="sm:hidden">Zurück</span>
            </Button>
          </Link>
        </div>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 py-20 md:py-32 max-w-4xl">
        <h1 className="text-2xl md:text-4xl font-heading font-bold mb-6 md:mb-8 text-black">Impressum</h1>
        
        <p className="text-xs text-gray-500 mb-6">Stand: Januar 2025</p>
        
        <div className="prose prose-sm md:prose-lg prose-neutral max-w-none [&>h2]:text-lg [&>h2]:md:text-xl [&>h2]:font-bold [&>h2]:mt-6 [&>h2]:md:mt-8 [&>h2]:mb-3 [&>h2]:md:mb-4 [&>p]:text-sm [&>p]:md:text-base [&>p]:mb-4 [&>p]:leading-relaxed">
        
        <h2>Angaben gemäß § 5 DDG</h2>
        <p>
          <strong>Bürokult GmbH</strong><br/>
          Espachstraße 13<br/>
          88453 Erolzheim<br/>
          Deutschland
        </p>

        <p>
          <strong>Handelsregister:</strong> HRB 746618<br/>
          <strong>Registergericht:</strong> Amtsgericht Ulm
        </p>

        <p>
          <strong>Vertreten durch den Geschäftsführer:</strong><br/>
          Alexander Simon Baur
        </p>

        <h2>Kontakt</h2>
        <p>
          Telefon: <a href="tel:+4973549469200" className="hover:underline">+49 (0) 7354 94692-0</a><br/>
          E-Mail: <a href="mailto:info@buerokult.de" className="hover:underline">info@buerokult.de</a><br/>
          Website: <a href="https://www.teamwerk-erolzheim.de" className="hover:underline">www.teamwerk-erolzheim.de</a>
        </p>

        <h2>Umsatzsteuer-Identifikationsnummer</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br/>
          <strong>DE 362 926 060</strong>
        </p>

        <h2>Berufshaftpflichtversicherung</h2>
        <p>
          <strong>Name und Sitz des Versicherers:</strong><br/>
          Württembergische Versicherung AG<br/>
          Gutenbergstraße 30<br/>
          70176 Stuttgart
        </p>
        <p>
          <strong>Geltungsraum der Versicherung:</strong><br/>
          Deutschland, Österreich, Schweiz, Europäische Union
        </p>

        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Alexander Baur<br/>
          Espachstraße 13<br/>
          88453 Erolzheim
        </p>

        <h2>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>

        <h2>Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            <strong>Hinweis:</strong> Dieses Impressum gilt auch für unsere Social-Media-Auftritte.
          </p>
        </div>

        </div>
      </div>
    </div>
  );
};

export default Impressum;
